import { gql, useQuery } from '@apollo/client';
import {
  GetFlashSenderHistoriesQuery,
  GetFlashSenderHistoriesQueryVariables,
} from '../../../../../__generated__/queries-newsletter';

export const GET_FLASH_SENDER_HISTORIES = gql`
  query GetFlashSenderHistories(
    $where: FlashSenderHistoryWhereInput
    $orderBy: [FlashSenderHistoryOrderByInput!]
    $first: Int!
    $skip: Int
  ) {
    flashSenderHistories(
      where: $where
      orderBy: $orderBy
      first: $first
      skip: $skip
    ) {
      id
      createdAt
    }
  }
`;

export const useFlashSenderHistories = (
  variables: GetFlashSenderHistoriesQueryVariables,
) =>
  useQuery<GetFlashSenderHistoriesQuery, GetFlashSenderHistoriesQueryVariables>(
    GET_FLASH_SENDER_HISTORIES,
    {
      variables,
    },
  );
